var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-base font-normal cursor-pointer",attrs:{"data-testid":_vm.dataTestId},on:{"click":function($event){return _vm.$emit('click', _vm.url)}}},[_vm._v("\n  "+_vm._s(_vm.url.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }